export default {
  path: '/esg',
  title: 'ESG统计',
  title_EN: 'ESG Statistics',
  icon: 'mdi-chart-box-outline',
  access: 'ESG统计',

  children: [
    {
      title: '海务',
      icon: 'mdi-waves',
      group: '/sea',
      children: [
        {
          path: '/esg/harmless-waste',
          name: 'harmless-waste',
          component: () =>
            import('@/views/maritime-affairs/esg/harmless-waste'),
          meta: {
            title: '无害垃圾',
            access: '无害垃圾:列表',
          },
        },
        {
          path: '/esg/harmful-waste',
          name: 'harmful-waste',
          component: () => import('@/views/maritime-affairs/esg/harmful-waste'),
          meta: {
            title: '有害垃圾',
            access: '有害垃圾:列表',
          },
        },
        {
          path: '/esg/fresh-water',
          name: 'fresh-water',
          component: () => import('@/views/maritime-affairs/esg/fresh-water'),
          meta: {
            title: '淡水',
            access: '淡水:列表',
          },
        },
        {
          path: '/esg/ballast-water',
          name: 'ballast-water',
          component: () => import('@/views/maritime-affairs/esg/ballast-water'),
          meta: {
            title: '压载水',
            access: '压载水:列表',
          },
        },
        // {
        //   path: '/esg/pressure-influence-detail/:id',
        //   name: 'pressure-influence-detail',
        //   component: () =>
        //     import('@/views/maritime-affairs/esg/pressure-influence-detail'),
        //   meta: {
        //     title: '冷高压影响详情',
        //     access: '冷高压影响:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
  ],
}
